import React from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PageComments from './PageComments';

const CommentsPanel = ({ pageid, spaceid, onClose }) => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          borderBottom: '1px solid #eee',
          paddingBottom: 10,
        }}
      >
        <h4 style={{ margin: 0 }}>Comments</h4>

        <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
      </div>

      <div style={{ overflowY: 'auto', flex: 1 }}>
        <div style={{ marginBottom: 24 }}>
          <PageComments
            pageid={pageid}
            spaceid={spaceid}
            type="inline"
            isPanel={true}
          />
        </div>

        <div
          style={{ borderTop: '1px solid #eee', marginTop: 40, paddingTop: 20 }}
        >
          <h3>General Comments</h3>
          <PageComments
            pageid={pageid}
            spaceid={spaceid}
            type="page"
            isPanel={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CommentsPanel;
